import * as Sentry from '@sentry/vue';
import { useEventStore } from '~~/stores/event';
import { version } from '~~/package.json'

export default defineNuxtPlugin(async (nuxtApp) => {

  // let isLocal = window.location.protocol == 'http:'
  // let isTestLiff_1 = window.location.origin?.includes("https://photowishv2-connect-liff--preview-liff-0e2iikt3.web.app")
  // let isTestLiff_2 = window.location.origin?.includes("https://test-invite-client-liff-4.netlify")
  // if (isLocal || isTestLiff_1 || isTestLiff_2) {
  //   return
  // }

  

  // console.log('hello from sentry client')


  // const { public: { sentry } } = useRuntimeConfig()

  // Sentry.init({
  //   app: nuxtApp.vueApp,
  //   dsn: sentry.dsn,
  //   environment: sentry.environment,
  //   release: "photowish-client-lift-v2@1.0.0",
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration({
  //       maskAllText: false,
  //       blockAllMedia: false,
  //     }),
  //   ],
  //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // })


  // let eventStore = useEventStore()
  // watch(() => eventStore.eventId, (a, b) => {
  //   Sentry.setUser({
  //     eventId: eventStore.eventId,
  //   })
  // })

  // nuxtApp.provide('Sentry', Sentry)
  // nuxtApp.vueApp.config.errorHandler = (err: any, vm, info) => {
  //   Sentry.captureMessage(err);
  // }
})


function mockError() {
  return new Promise((resolve, reject) => {

    reject('mock error')
  })
}

